import {IconSize} from '../enums/icon-size.enum';
import {IconColour} from '../enums/icon-colour.enum';

export class IconViewModel {
  readonly url: string;
  readonly alt: string;
  readonly order: number;
  readonly size: IconSize;
  readonly colour: IconColour;

  constructor(url: string, alt: string, order: number, size: IconSize, colour: IconColour) {
    this.url = url;
    this.alt = alt;
    this.order = order;
    this.size = size;
    this.colour = colour;
  }
}
